import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '@screen';
import styled from 'styled-components';

/**
 * Styled text component for "Keep Watching" label in pause ad modal.
 * Displays the keep watching section title at the bottom of the modal.
 */
const PauseAdKeepWatchingText = styled.span<React.CSSProperties>`
  position: fixed;
  color: ${Colors['text']};
  font-family: ${Fonts['regular']};
  font-size: ${Screen.widthRatio * 30}px;
  left: ${Screen.widthRatio * 85}px;
  top: ${Screen.widthRatio * 960}px;
}
`;

export default PauseAdKeepWatchingText;
